<template>
  <div id="app">
<!-- 			<keep-alive v-if='this.$route.meta.keepAlive'>
				<router-view></router-view>
			</keep-alive> -->
			<router-view></router-view>
  </div>
</template>

<script>
export default {
  mounted() {
  }

}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.slide-fade{
  position: absolute;left:0;right: 0;
}
.slide-fade-enter-active {
  transition: all 1.2s ease;
}
.slide-fade-leave-active {

  transition: all .5s cubic-bezier(2.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
{
  left:0;right: 0;
  transform: translateX(50px);
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/App.vue